import React from 'react';
import CustomerReminder from './containers/CustomerReminder';
import HoursMinsSelect from './components/HoursMinsSelect';
import Row from './components/Row';
import Common from './Common';
import { t } from 'js/modules/infra/i18n';

class ShopNotificationMethods extends Common {
  renderArrived() { // eslint-disable-line
    return (
      <Row className="u-mb-" label={t('admin:shops.add.arrived_label')} action="notifications.arrived" hide={this.props.commonHiddenFields} />
    );
  }
  renderReminders() { // eslint-disable-line
    return (
      <div>
        <div className="u-mb-">
          <Row label={t('admin:shops.add.reminder')} action="notifications.reminder" hide={this.props.commonHiddenFields} />
          <HoursMinsSelect label={`${t('admin:shops.add.reminder_label')}:`} name="notifications.reminder.time" />
        </div>
        <div className="u-mb-">
          <div className="c-label c-label--light u-pb--">{t('admin:shops.add.client_notifications_label')}</div>
          <CustomerReminder name="customerReminder" commonHiddenFields={this.props.commonHiddenFields} />
        </div>
      </div>
    );
  }
}

export default ShopNotificationMethods;
